import { Action, createReducer } from '@ngrx/store';
import { immerOn } from 'ngrx-immer/store';
import * as MarketActions from './market.action';
import * as moment from 'moment';
import { stat } from 'fs';
export const MarketFeatureKey = 'Market';

export interface MarketState {
  readonly [MarketFeatureKey]: any;
}

export const MarketInitialState: any = {
  error: '',
  user:'',
  loading:false,
  login:'',
  nfts:[],
  allMissions:[],
  myMissions:[],
  isNav:false,
  showProfileEdit:false,
  purchase:'',
  burn:[],
  trans:[],
  pop:'',
  tokens:0,
  burned:false,
  claim:false,
  showNfts:[],
  notifications:[],
  levels:[],
  filteredMissions:[],
  filter:{
    OnMissions:false,
    AllMissions:true,
    AvailableMissions:false,
    Claimable:false
  },
  inventory:[],
  myInventory:[],
  scores:[],
  userScore:'',
  allSkills:[],
  season:{},
  pastSeason:{},
  onMissions:0,
  claimable:0,
  selectDetails:'',
  selectPack:'',
  pass:[],
  passrewards:[],
  userSeasonRewards:[],
  eth:0,
  packSigs:[],
  packs:[],
  cards:[],
  opened:'',
  approval:false,
  upgrade:'',
  allSell:[],
  userSell:[],
  modal:false,
  shareprofile:false,
  mobileMenu:false
}

const reducer = createReducer(
    MarketInitialState,
//UNIVERSAL
  immerOn(MarketActions.loadingStart, (state:any, action:any) => {
    state.loading = action.data;
  }),

  immerOn(MarketActions.mobileMenuSuccess, (state:any, action:any) => {
    state.mobileMenu = action.data;
  }),

  immerOn(MarketActions.setFilterSuccess, (state:any, action:any) => {
    state.filter = action.filter;
    state.error = '';

    
  }),

  immerOn(MarketActions.getUserSuccess, (state:any, action:any) => {
    state.user = action.user;
    state.packSigs = action.packSigs;
    state.user.missionsComp=action.missionsComp;
    state.allSkills = action.allSkills;
    state.pass=action.pass;
    state.passrewards = action.passrewards;
    state.userSeasonRewards=action.userSeasonRewards;
    state.error = '';
    
    
  }),

  immerOn(MarketActions.getUserFail, (state:any, action:any) => {
    state.error=action.error.message;
    state.user = '';
    state.packSigs = [];
    state.claim = 0;
  }),

  immerOn(MarketActions.getSeasonsSuccess, (state:any, action:any) => {
    state.season = action.season;
    state.pastSeason=action.pastSeason;
    state.error = '';

    
  }),

  immerOn(MarketActions.shareprofileSuccess, (state:any, action:any) => {
    state.shareprofile = action.data;
    

    
  }),

  immerOn(MarketActions.getSeasonsFail, (state:any, action:any) => {
    state.error=action.error.message;
    
  }),

  immerOn(MarketActions.levelsSuccess, (state:any, action:any) => {
    state.levels = action.levels;
    state.error = '';

    
  }),

  immerOn(MarketActions.levelsFail, (state:any, action:any) => {
    state.error=action.error.message;
    state.levels = [];
  }),

  immerOn(MarketActions.ethSuccess, (state:any, action:any) => {
    state.eth = action.eth;
    state.error = '';
  }),

  immerOn(MarketActions.ethFail, (state:any, action:any) => {
    state.error=action.error.message;
    state.eth = 0;
  }),
  
  immerOn(MarketActions.loginSuccess, (state:any, action:any) => {
    state.login = action.wallet;
    state.eth = action.eth;
    state.approval=action.allow;
    state.error = '';
  }),

  immerOn(MarketActions.loginFail, (state:any, action:any) => {
    state.error=action.error.message;
    state.eth = 0;
    state.login = '';
  }),

  immerOn(MarketActions.logoutSuccess, (state:any, action:any) => {
    state.login = '';
    state.user = '';
    state.nfts=[];
    state.showNfts=[]
    
  }),

  immerOn(MarketActions.logoutFail, (state:any, action:any) => {
    state.error=action.error.message;

  }),

  immerOn(MarketActions.getNftsSuccess, (state:any, action:any) => {
  state.showNfts=action.Nfts.showNfts;
   state.nfts = action.Nfts.nfts;
    state.error = '';
  }),

  immerOn(MarketActions.getNftsFail, (state:any, action:any) => {
    state.error=action.error.message;
    state.nfts = '';
  }),

  immerOn(MarketActions.packsSuccess, (state:any, action:any) => {
    state.packs=action.packs;
     state.loading = false;
      state.error = '';
    }),
  
    immerOn(MarketActions.packsFail, (state:any, action:any) => {
      state.error=action.error.message;
      state.packs = [];
    }),

  immerOn(MarketActions.getAllMissionsSuccess, (state:any, action:any) => {
    state.allMissions = action.missions;
    state.error = '';
  }),

  immerOn(MarketActions.getAllMissionsFail, (state:any, action:any) => {
    state.error=action.error;
    state.allMissions = [];
 
  }),

  immerOn(MarketActions.getMyMissionsSuccess, (state:any, action:any) => {
    state.myMissions = action.myMissions;
    state.error = '';
  }),

  immerOn(MarketActions.getMyMissionsFail, (state:any, action:any) => {
    state.error=action.error;
    state.myMissions = [];
 
  }),


  immerOn(MarketActions.purchaseSuccess, (state:any, action:any) => {
    state.purchase = true;
    state.error = '';
  }),

  immerOn(MarketActions.purchaseFail, (state:any, action:any) => {
    state.error=action.error;
    state.purchase = '';
 
  }),

  immerOn(MarketActions.purchaseInventorySuccess, (state:any, action:any) => {
    state.myInventory = action.myinventory;
    state.error = '';
  }),

  immerOn(MarketActions.purchaseInventoryFail, (state:any, action:any) => {
    state.error=action.error;
 
  }),

  immerOn(MarketActions.useItemSuccess, (state:any, action:any) => {
    state.missions = action.missions;
    state.error = '';
  }),

  immerOn(MarketActions.useItemFail, (state:any, action:any) => {
    state.error=action.error;
 
  }),

  immerOn(MarketActions.inventorySuccess, (state:any, action:any) => {
    state.inventory = action.inventory;
    state.error = '';
  }),

  immerOn(MarketActions.inventoryFail, (state:any, action:any) => {
    state.error=action.error;
 
  }),

  immerOn(MarketActions.myinventorySuccess, (state:any, action:any) => {
    state.myInventory = action.myinventory;
    state.userSell=action.userSell;
    state.error = '';
  }),

  immerOn(MarketActions.myinventoryFail, (state:any, action:any) => {
    state.error=action.error;
 
  }),

  immerOn(MarketActions.allSellSuccess, (state:any, action:any) => {
    state.allSell = action.allSell;
    
    state.error = '';
  }),

  immerOn(MarketActions.allSellFail, (state:any, action:any) => {
    state.error=action.error;
 
  }),

  immerOn(MarketActions.burnPassSuccess, (state:any, action:any) => {
    state.loading = false;
  }),

  immerOn(MarketActions.burnPassFail, (state:any, action:any) => {
    state.error=action.error;
    state.loading = false;
  }),

  immerOn(MarketActions.passSignatureSuccess, (state:any, action:any) => {
    
  }),

  immerOn(MarketActions.passSignatureFail, (state:any, action:any) => {
    state.error=action.error;
    state.loading = false;
  }),


  immerOn(MarketActions.setNavSuccess, (state:any, action:any) => {
    state.isNav=action.isNav;
   
  }),

  immerOn(MarketActions.showProfileEditSuccess, (state:any, action:any) => {

    state.showProfileEdit=action.data;
    console.log(state.showProfileEdit)
  }),

  immerOn(MarketActions.myMissionDetailsSuccess, (state:any, action:any) => {
    state.onMissions=action.onMissions;
    state.claimable=action.claimable;
  }),


  immerOn(MarketActions.popupSuccess, (state:any, action:any) => {
    state.pop=action.pop;
   
  }),

  immerOn(MarketActions.missionsFilterSuccess, (state:any, action:any) => {
    state.filteredMissions = action.missions;
    state.filter = action.filter;
    state.error = '';
  }),

  immerOn(MarketActions.claimRewardSuccess, (state:any, action:any) => {
    state.claim = true;
    state.error = '';
  }),

  immerOn(MarketActions.claimRewardFail, (state:any, action:any) => {
    state.error=action.error;
    state.claim = '';
 
  }),

  immerOn(MarketActions.claimPassRewardSuccess, (state:any, action:any) => {
    state.pass = action.pass;
    state.passrewards = action.passrewards;
    state.myInventory = action.myInventory;
    state.error = '';
  }),

  immerOn(MarketActions.claimPassRewardFail, (state:any, action:any) => {
    state.error=action.error;
   
 
  }),

  immerOn(MarketActions.claimSeasonRewardSuccess, (state:any, action:any) => {
    state.userSeasonRewards = action.userSeasonRewards;
    state.myInventory = action.myInventory;
    state.error = '';
  }),

  immerOn(MarketActions.claimSeasonRewardFail, (state:any, action:any) => {
    state.error=action.error;
   
 
  }),

  immerOn(MarketActions.scoreboardSuccess, (state:any, action:any) => {
    state.scores = action.scores;
    state.userScore=action.userScore;
    state.error = '';
  }),

  immerOn(MarketActions.scoreboardFail, (state:any, action:any) => {
    state.error=action.error;
    state.scores = [];
 
  }),

  immerOn(MarketActions.selectDetailsSuccess, (state:any, action:any) => {
    state.selectDetails = action.data;
  }),

  immerOn(MarketActions.upgradeNFTSuccess, (state:any, action:any) => {
    state.upgrade = action.card;
    state.loading=false;
  }),

  immerOn(MarketActions.upgradeNFTFail, (state:any, action:any) => {

    state.loading=false;
  }),

  immerOn(MarketActions.closeUpgrade, (state:any, action:any) => {
    state.upgrade = '';
  }),

  immerOn(MarketActions.selectPackSuccess, (state:any, action:any) => {
    state.selectPack = action.data;
    state.opened= '';
  }),

  immerOn(MarketActions.packOpenSuccess, (state:any, action:any) => {
    state.opened = action.card;
    state.selectPack='';
    state.loading=false;
  }),

  immerOn(MarketActions.closeOpen, (state:any, action:any) => {
    state.opened = '';
  }),

  immerOn(MarketActions.packOpenFail, (state:any, action:any) => {

    state.loading=false;
  }),

  immerOn(MarketActions.packInteractionSuccess, (state:any, action:any) => {
    state.packSigs = [];
    state.loading=false;
  }),

  immerOn(MarketActions.packInteractionFail, (state:any, action:any) => {

    state.loading=false;
  }),

  immerOn(MarketActions.checkApprovalSuccess, (state:any, action:any) => {
    state.approval = action.approval;
  }),

  immerOn(MarketActions.closeModalSuccess, (state:any, action:any) => {
    state.modal = false;
  }),

  immerOn(MarketActions.deployToMissionSuccess, (state:any, action:any) => {
    state.modal = true;
  }),


);

export function MarketReducer(state: any, action: Action): any {
    return reducer(state, action);
}